/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RsrImportAntwort } from './RsrImportAntwort';
import {
    RsrImportAntwortFromJSON,
    RsrImportAntwortFromJSONTyped,
    RsrImportAntwortToJSON,
} from './RsrImportAntwort';

/**
 * 
 * @export
 * @interface RsrImporteAusschnitt
 */
export interface RsrImporteAusschnitt {
    /**
     * Anzahl der zurückgegebenen RSR-Importe.
     * @type {number}
     * @memberof RsrImporteAusschnitt
     */
    anzahlRsrImporte: number;
    /**
     * Anzahl der für den Filter zur Verfügung stehenden RSR-Importe.
     * @type {number}
     * @memberof RsrImporteAusschnitt
     */
    anzahlRsrImporteGesamt: number;
    /**
     * 
     * @type {Array<RsrImportAntwort>}
     * @memberof RsrImporteAusschnitt
     */
    rsrImporte: Array<RsrImportAntwort>;
}

/**
 * Check if a given object implements the RsrImporteAusschnitt interface.
 */
export function instanceOfRsrImporteAusschnitt(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "anzahlRsrImporte" in value;
    isInstance = isInstance && "anzahlRsrImporteGesamt" in value;
    isInstance = isInstance && "rsrImporte" in value;

    return isInstance;
}

export function RsrImporteAusschnittFromJSON(json: any): RsrImporteAusschnitt {
    return RsrImporteAusschnittFromJSONTyped(json, false);
}

export function RsrImporteAusschnittFromJSONTyped(json: any, ignoreDiscriminator: boolean): RsrImporteAusschnitt {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'anzahlRsrImporte': json['anzahlRsrImporte'],
        'anzahlRsrImporteGesamt': json['anzahlRsrImporteGesamt'],
        'rsrImporte': ((json['rsrImporte'] as Array<any>).map(RsrImportAntwortFromJSON)),
    };
}

export function RsrImporteAusschnittToJSON(value?: RsrImporteAusschnitt | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'anzahlRsrImporte': value.anzahlRsrImporte,
        'anzahlRsrImporteGesamt': value.anzahlRsrImporteGesamt,
        'rsrImporte': ((value.rsrImporte as Array<any>).map(RsrImportAntwortToJSON)),
    };
}

